import React from "react";
import { useParams } from "react-router-dom";
import { useGetRewardByIdQuery } from "../rewards.service";
import PageLoading from "src/components/pageLoading";
import RewardForm from "../components/RewardForm";

const EditRewardPage = () => {
  const { rewardId } = useParams<{ rewardId: string }>();
  const { data: reward, isLoading } = useGetRewardByIdQuery(rewardId!);

  if (isLoading) return <PageLoading />;
  if (!reward) return <div className="p-8 text-center text-gray-500">Reward not found.</div>;

  return <RewardForm initialData={reward} />;
};

export default EditRewardPage;
